module.exports = __webpack_public_path__ + "static/img/填写真实信息.85deb01.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/填写真实信息.png
// module id = 610
// module chunks = 382